var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sub-page',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"description":_vm.description,"button-text":_vm.buttonText,"bg":_vm.bg,"right-bg":_vm.rightBg,"right-bg2":_vm.rightBg2,"rbg2Style":{ transform: 'rotateZ(-20deg)' },"partition":[7, 5]}})
}
var staticRenderFns = []

export { render, staticRenderFns }